export function getItemImage(item, size = 'sm') {
  const SIZE_MAP = {
    xs: 'thumbnail',
    sm: 'small',
    md: 'med',
    lg: 'large',
  };
  const image = item.images?.[0]?.[`image_${SIZE_MAP[size]}`] || item.image;
  if (image) {
    return image;
  }
  // Todo: uncomment if needed
  // if (item.are_item_images_visible && config?.placeholder_img) {
  //   return config?.placeholder_img;
  // }
  if (item.are_item_images_visible && item.placeholder_image) {
    return item.placeholder_image;
  }
  return null;
}

export const getItemPrices = ({ item, size } = {}) => {
  if (!size) {
    size = item.minimum_size;
  }
  const price = size.marked_up_price;
  const discountedPrice = size.discounted_marked_up_price;

  return { price, discountedPrice: discountedPrice ? +discountedPrice : null };
};

export const getItemTotalPrice = ({
  item_related, size, qty, order_options,
}) => {
  const prices = getItemPrices({ item: item_related, size });
  const itemPrice = prices.discountedPrice || prices.price;
  const modifiersPrice = getModifiersPrice(order_options ?? []);
  return (qty || 1) * (itemPrice + modifiersPrice);
};

export function getModifiersPrice(modifiers) {
  return modifiers.reduce(
    (total, m) => total + (m.real_price || 0) * m.qty,
    0,
  );
}

export const getTotalOrderValue = (items) => {
  let total = 0;
  items?.map((item) => total += getItemTotalPrice(item));
  return total;
};

export const getItemTotalRealPrice = ({
  item_related, size, qty, order_options,
}) => {
  const prices = getItemPrices({ item: item_related, size });
  const itemPrice = prices.price;
  const modifiersPrice = getModifiersPrice(order_options ?? []);
  return (qty || 1) * (itemPrice + modifiersPrice);
};
